import { useState } from "react";
import Switch from '@mui/material/Switch';
import { MainLayout } from "../../layout/MainLayout";
import { Grid } from "../../UI/Grid";
import { Typography } from "../../UI/Typography";
import { MatchingRoundRows } from "../../components/MatchingRoundRows";

const HomePage = () => {
  const [showArchived, setShowArchived] = useState(false);

  const handleToggleArchiveChange = (_, checked) => setShowArchived(checked);

  return (
    <MainLayout
      title="Dashboard"
      endAdornment={
        <Typography variant="body2">
          Show Archived
          <Switch value={showArchived} onChange={handleToggleArchiveChange}/>
        </Typography>
      }
    >
      <Grid container item xs={12}>
        <MatchingRoundRows showArchived={showArchived} />
      </Grid>
    </MainLayout>
  );
};

export default HomePage;
export const HOME_URL = "/home";
